module.exports = __webpack_public_path__ + "img/QRprod.cf23df36.png";